import { StorySlug } from "./episodes-types";

export enum PromptType {
  image = "image",
  text = "text",
}

export type Prompt = {
  id: string;
  name: string;
  storyType: StorySlug;
  type: PromptType;
  description?: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  revisions: PromptRevision[];
};

export type PromptRevision = {
  id: string;
  prompt?: string; // can be omitted in list endpoints
  revision: number;
  revisionNote?: string;
  createdAt: string;
  updatedAt: string;
  logicalPrompt: Prompt;
};

export type CreatePrompt = {
  name: string;
  storyType: StorySlug;
  prompt: string;
  revisionNote?: string;
  description?: string;
  type: PromptType;
};

export type UpdatePrompt = {
  description: string;
};

export type CreatePromptRevision = {
  prompt: string;
  revisionNote?: string;
};
